<template>
    <div class="container-fluid">
        <div class="row no-gutter">
            <div class="col-lg-3 bg-image"></div>
            <div class="col-lg-9">
                <div class="login d-flex align-items-center">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 mx-auto">
                                <div class="my-4 text-center">
                                    <img class="img-fluid" src="/client/images/logo-login.png" />
                                </div>

                                <vue-form-card
                                    color-class="bg-white"
                                    class="dark-border"
                                    margin-class="mb-0"
                                    padding-class="px-4 px-md-8 pt-8 pb-0"
                                >
                                    <template v-slot:title>Personal details</template>

                                    <template v-slot:body>
                                        <hr class="mt-3" />

                                        <div class="row mt-4">
                                            <div class="col-12 col-md-6">
                                                <vue-text-input
                                                    v-model="form.firstName"
                                                    label="First name"
                                                    :required="true"
                                                    :errors="formErrors['firstName']"
                                                />
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <vue-text-input
                                                    v-model="form.lastName"
                                                    label="Last name"
                                                    :required="true"
                                                    :errors="formErrors['lastName']"
                                                />
                                            </div>
                                        </div>

                                        <vue-text-input
                                            class="mt-5"
                                            v-model="form.email"
                                            label="Email address"
                                            :required="true"
                                            :errors="formErrors['email']"
                                        />

                                        <vue-text-input
                                            class="mt-5"
                                            v-model="form.password"
                                            label="Password"
                                            type="password"
                                            :required="true"
                                            :errors="formErrors['password']"
                                        />

                                        <vue-text-input
                                            class="mt-5"
                                            v-model="form.confirmPassword"
                                            label="Confirm password"
                                            type="password"
                                            :required="true"
                                            :errors="formErrors['confirmPassword']"
                                        />

                                        <small class="font-italic text-muted">
                                            The password must have minimum 6 characters
                                        </small>

                                        <vue-text-input
                                            class="mt-5"
                                            v-model="form.phoneNumber"
                                            label="Phone number"
                                            type="text"
                                            :required="true"
                                            :errors="formErrors['phoneNumber']"
                                        />
                                    </template>
                                </vue-form-card>

                                <vue-form-card color-class="bg-white" class="dark-border">
                                    <template v-slot:title>Address</template>

                                    <template v-slot:body>
                                        <hr class="mt-3" />

                                        <vue-text-input
                                            label="Postal code"
                                            class="mt-4 mb-5"
                                            :required="true"
                                            v-model="form.address.postalCode"
                                            :errors="formErrors['address.postalCode']"
                                            :loading="loading.postalCode"
                                        />

                                        <vue-text-input
                                            label="Street address"
                                            class="mb-5"
                                            :required="true"
                                            v-model="form.address.line1"
                                            placeholder="Street and number, P.O.box, c/o"
                                            :errors="formErrors['address.line1']"
                                        />

                                        <vue-text-input
                                            label="Street address 2"
                                            class="mb-5"
                                            v-model="form.address.line2"
                                            placeholder="Flat, suite, unit, building, floor, etc"
                                            :errors="formErrors['address.line2']"
                                        />

                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <vue-text-input
                                                    class="mb-5 mb-md-0"
                                                    label="City"
                                                    :required="true"
                                                    v-model="form.address.city"
                                                    :errors="formErrors['address.city']"
                                                />
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <vue-select-input
                                                    label="County"
                                                    :required="true"
                                                    :loading="loading.counties"
                                                    :data="counties"
                                                    :data-value="(item) => item.id"
                                                    :data-text="(item) => item.name"
                                                    v-on:page-changed="countiesPaginator.page = $event"
                                                    v-on:search="searchCounties"
                                                    v-model="form.address.county"
                                                    :errors="formErrors['address.county']"
                                                />
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-center mt-5">
                                            <button
                                                type="button"
                                                class="btn btn-primary w-100 w-md-50"
                                                :disabled="loading.create"
                                                v-on:click="create"
                                            >
                                                <i class="fa fa-spinner fa-spin" v-if="loading.create"></i>
                                                Continue
                                            </button>
                                        </div>
                                    </template>
                                </vue-form-card>
                            </div>

                            <small class="text-muted mx-auto mb-4 px-4 px-md-0">
                                18 St George's Place, Cheltenham, Gloucestershire. GL50 3JZ
                                <br />
                                T: 01242 571883 | E: office@owltherapycentre.co.uk
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { debounce } from 'lodash';

    import authService from '@api/auth';
    import addressesService from '@api/addresses';

    import VueFormCard from '@components/formCard';
    import VueTextInput from '@components/textInput';
    import VueSelectInput from '@components/selectInput';

    export default Vue.extend({
        components: {
            VueFormCard,
            VueTextInput,
            VueSelectInput
        },
        data() {
            return {
                form: authService.toVue(),
                formErrors: {},
                counties: {},
                countiesPaginator: countiesPaginator(),
                user: authService.user,
                loading: {
                    create: false,
                    counties: false,
                    postalCode: false
                }
            };
        },
        watch: {
            countiesPaginator: {
                deep: true,
                handler() {
                    this.fetchCounties();
                }
            },
            'form.address.postalCode'() {
                this.checkPostalCode();
            }
        },
        methods: {
            fetchCounties() {
                this.loading.counties = true;

                addressesService
                    .counties(this.countiesPaginator)
                    .then((response) => {
                        this.counties = response.data;
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    })
                    .finally(() => {
                        this.loading.counties = false;
                    });
            },
            searchCounties: debounce(function(term) {
                this.countiesPaginator.page = 1;
                this.countiesPaginator.term = term;
            }, 500),
            checkPostalCode: debounce(function() {
                if (this.formErrors && this.formErrors['address.postalCode']) {
                    this.$delete(this.formErrors, 'address.postalCode');
                }

                this.form.address.latitude = null;
                this.form.address.longitude = null;
                this.loading.postalCode = true;

                addressesService
                    .checkPostalCode(this.form.address.postalCode)
                    .then((response) => {
                        this.form.address.latitude = response.data.result.latitude;
                        this.form.address.longitude = response.data.result.longitude;
                    })
                    .catch((error) => {
                        this.$set(this.formErrors, 'address.postalCode', ['The provided postal code is invalid']);
                    })
                    .finally(() => {
                        this.loading.postalCode = false;
                    });
            }, 500),
            create() {
                authService
                    .register(this.form)
                    .then(() => {
                        this.$router.push('/enquiries');
                    })
                    .catch((error) => {
                        if (error.response.data.errors) {
                            this.formErrors = error.response.data.errors;
                            this.$toasted.error(
                                'Please enter a valid value in all the required fields before proceeding.',
                                { icon: 'exclamation-triangle' }
                            );
                            this.$goToError();
                        } else {
                            window.location.href = `/error/${error.response.status}`;
                        }
                    });
            }
        },
        created() {
            window.document.title = `Register | ${window.app.title}`;
        },
        mounted() {
            if (this.form) {
                this.fetchCounties();
            }
        }
    });

    /** Paginators */
    const countiesPaginator = () => {
        return {
            term: null,
            page: 1,
            perPage: 4
        };
    };
</script>
